module.exports = __webpack_public_path__ + "img/croatia.b5e27ac5.svg";